import { features } from "@/mocks/home";

export default function Features() {
  return (
    <section id="features" className="scroll-mt-20 bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-1.5 text-xs font-medium text-secondary-800">
            <i className="ri-award-line"></i>
            韩漫在线的核心阅读体验
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            清爽、极速、沉浸的阅读方式
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            围绕每一位读者的真实需求打磨，韩漫在线的每一项功能都为了让追更更专注、更顺手。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((f) => (
            <article
              key={f.title}
              className="group rounded-xl border border-background-200 bg-background-50 p-6 transition-colors hover:border-primary-300"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-100 text-xl text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={f.icon}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">{f.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{f.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}